module.exports = __webpack_public_path__ + "static/media/black-add-edit-data-icon.e3646db7.svg";